<div [class]="'dpqa-dot variant-' + variant()"></div>
